import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import GetAppIcon from "@mui/icons-material/GetApp";
import request from "../../../../Helpers/API";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { useBox } from "../../../Finanzas/Helper/useBox";
import { GetKey } from "../../../Finanzas/Actions/GetContainer";
import { FiltroReporteGeolocalizacion } from "./FiltroReporteGeolocalizacion";
import { ReporteGeolocalizacionTabla } from "./ReporteGeolocalizacionTabla";

// Reporte de Geolocalización — tabla agrupada por asesor con filtro de ADR/Sucursal.
// "geolocalizacion" ya no tiene combo en la UI, se envía fijo como "C" al endpoint. Conectado a
// ReportesCRM/ReporteGeolocalizacion?geolocalizacion&adr&sucursal.
export const CRM_ReporteGeolocalizacion = () => {
  const history = useHistory();

  const [boxstate, setBoxState] = useBox({
    geolocalizacion: "C",
    pv: { adr: [], sucursal: [] },
  });

  const [listado, setListado] = useState([]);
  const [permisos, setPermisos] = useState();
  const [loader, setLoader] = useState({ mostrar: false, alerta: false, error: false, mensaje: "" });

  const cargarReporte = ({ geolocalizacion }) => {
    let adr = GetKey(boxstate.pv.adr, ["idadr"]);
    let sucursal = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    if (!adr) adr = "0";
    if (!sucursal) sucursal = "0";

    setLoader((prev) => ({ ...prev, mostrar: true }));
    request
      .get(`ReportesCRM/ReporteGeolocalizacion?geolocalizacion=${geolocalizacion || "C"}&adr=${adr}&sucursal=${sucursal}`)
      .then((result) => {
        setListado(Array.isArray(result?.listado) ? result.listado : []);
        setPermisos(result?.permisos);
        setLoader((prev) => ({ ...prev, mostrar: false }));
      })
      .catch((error) => {
        setLoader((prev) => ({ ...prev, mostrar: false }));
        Swal.fire("REPORTE DE GEOLOCALIZACIÓN", JSON.stringify(error), "error");
      });
  };

  useEffect(() => {
    cargarReporte({ geolocalizacion: boxstate.geolocalizacion });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Descarga el Excel del reporte — ReportesCRM/ImprimirExcelReporteGeolocalizacion.
  const onGeneraExcel = () => {
    let adr = GetKey(boxstate.pv.adr, ["idadr"]);
    let sucursal = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    if (!adr) adr = "0";
    if (!sucursal) sucursal = "0";

    setLoader((prev) => ({ ...prev, mostrar: true }));
    request
      .get(`ReportesCRM/ImprimirExcelReporteGeolocalizacion?geolocalizacion=${boxstate.geolocalizacion || "C"}&adr=${adr}&sucursal=${sucursal}`)
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = `${filename}.xlsx`;
        downloadLink.click();
        setLoader((prev) => ({ ...prev, mostrar: false }));
      })
      .catch((error) => {
        setLoader((prev) => ({ ...prev, mostrar: false }));
        Swal.fire("REPORTE DE GEOLOCALIZACIÓN", JSON.stringify(error), "error");
      });
  };

  return (
    <div className="crm-main-screen">
      <LoaderScreen loader={loader} />
      <div className="crm-body">
        <div className="crm-page rca-screen">
          <div className="crm-module">
            <div className="crm-module-head">
              <div className="crm-head-grid">
                <div className="crm-head-left">
                  <button className="crm-btn-regresar" onClick={() => history.goBack()}>
                    <ArrowBackIcon /> Regresar
                  </button>
                  <FiltroReporteGeolocalizacion onCargar={cargarReporte} boxState={boxstate} onBoxChange={setBoxState} permisos={permisos} />
                </div>
                <div className="crm-head-center">
                  <p className="crm-module-subtitle">Reportes</p>
                  <h1 className="crm-module-title">REPORTE DE GEOLOCALIZACIÓN</h1>
                </div>
                <div className="crm-head-right">
                  <button className="crmcs-btn-excel" onClick={onGeneraExcel}>
                    <GetAppIcon /> Excel
                  </button>
                </div>
              </div>
              <div className="crm-head-divider">
                <div className="crm-head-divider-dot" />
              </div>
            </div>

            <div className="crm-home-wrapper rca-wrapper scroll">
              <ReporteGeolocalizacionTabla listado={listado} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
